import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';
import { GlobalDataService } from 'src/app/services/data/global-data.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-email-templates-table',
  templateUrl: './email-templates-table.component.html',
  styleUrls: ['./email-templates-table.component.sass']
})
export class EmailTemplatesTableComponent extends BaseListDirective {


  refreshActionServices(): void {
    throw new Error('Method not implemented.');
  }

  form = {
    users: [],
    wall_id: null
  }
  userSelected
  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('TemplateName', 'FORM.NAME', 200, { frozen: true }),
  ];

  htmlSanitized;
  htmlTitle = ''
  visibleSidebarHtml = false

  isReponsableWarriorVisible = false
  override title = 'MENU.EMAIL-TEMPLATE';
  override filterableFields = ['TemplateName']
  override keys = {
    primary_key: '',
    label: 'TemplateName'
  }
  override filename = 'MENU.EMAIL-TEMPLATE';

  constructor(
    public utils: UtilsService,
    public data: GlobalDataService,
    protected route: ActivatedRoute,
    protected dialog: DialogService,
    protected dialogConfig: DynamicDialogConfig,
    protected dialogRef: DynamicDialogRef,
    private sanitizer: DomSanitizer
  ) {
    super(
      utils,
      data,
      route,
      dialog,
      dialogConfig,
      dialogRef,
    )
  }

  override getList(): void {
    this.query(this.data.core.EmailTemplate()).subscribe()

  }

  override handleRows(data: any): void {
    super.handleRows(data);
  }




  handleView(item) {
    this.data.core.emailTemplateUnique(item.TemplateName)
      .subscribe(tmp => {

        this.htmlSanitized = this.sanitizer.bypassSecurityTrustHtml(tmp.TemplateContent.Html)
        this.htmlTitle = tmp.TemplateContent.Subject

        this.visibleSidebarHtml = true


      })
  }




}
